import React from 'react';
import * as dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { Error } from './error';

function Input({
  label,
  max,
  min,
  name,
  placeholder,
  required = true,
  step,
  type = 'text',
  register,
  errors,
}) {
  const MIN_LENGTH = type === 'tel' ? 8 : 2;

  // Everything except weekend days
  // const validate = (dateString) => {
  //   const day = new Date(dateString).getDay();
  //   if (day === 0 || day === 6) {
  //     return false;
  //   }
  //   return true;
  // };

  // // Sets the value to '' in case of an invalid date
  // if (document.querySelector("input[type='date'")) {
  //   document.querySelector("input[type='date']").onchange = (evt) => {
  //     if (!validate(evt.target.value)) {
  //       evt.target.value = '';
  //     }
  //   };
  // }

  /** **********************************************
  ***************************************************
  *********************************************************
  *******************************************************
  Try using the register() function to check for the invalid dates
  *******************************************************
  ******************************************************** */

  return (
    <div>
      <label htmlFor={name}>
        <span>{`${label}${required ? ' *' : ''}`}</span>
        <div className="relative mt-1">
          {type === 'date' ? (
            <input
              id={name}
              name={name}
              type={type}
              min={min}
              max={max}
              step={step}
              required={required}
              placeholder={placeholder}
              aria-invalid={!!errors[name]}
              ref={register({
                validate: (v) => {
                  const blocked = [
                    '2022-12-23',
                    '2022-12-24',
                    '2022-12-25',
                    '2022-12-26',
                    '2022-12-27',
                    '2022-12-28',
                    '2022-12-29',
                    '2022-12-30',
                    '2022-12-31',
                    '2023-01-01',
                    '2023-01-02',
                  ];
                  return (
                    !blocked.includes(v) || (
                      <Error message="Cake pickups unavailable from Dec. 23 to Jan. 2. Please choose a different date." />
                    )
                  );
                },
                required: required && (
                  <Error message="This field is required" />
                ),
                min: min && {
                  value: min,
                  message: (
                    <Error
                      message={`The minimum value for this field is ${dayjs(
                        min
                      ).format('DD/MM/YYYY')}`}
                    />
                  ),
                },
                max: max && {
                  value: max,
                  message: (
                    <Error
                      message={`The maximum value for this field is ${dayjs(
                        max
                      ).format('DD/MM/YYYY')}`}
                    />
                  ),
                },
                minLength: {
                  value: MIN_LENGTH,
                  message: (
                    <Error
                      message={`Must be at least ${MIN_LENGTH} characters`}
                    />
                  ),
                },
              })}
              className={`block w-full px-4 py-2 mt-1 transition duration-150 ease-in-out rounded-lg form-input ${
                errors[name]?.message ? 'border-red-300' : 'border-gray-300'
              }`}
            />
          ) : (
            <input
              id={name}
              name={name}
              type={type}
              min={min}
              max={max}
              step={step}
              required={required}
              placeholder={placeholder}
              aria-invalid={!!errors[name]}
              ref={register({
                required: required && (
                  <Error message="This field is required" />
                ),
                min: min && {
                  value: min,
                  message: (
                    <Error
                      message={`The minimum value for this field is ${dayjs(
                        min
                      ).format('DD/MM/YYYY')}`}
                    />
                  ),
                },
                max: max && {
                  value: max,
                  message: (
                    <Error
                      message={`The maximum value for this field is ${dayjs(
                        max
                      ).format('DD/MM/YYYY')}`}
                    />
                  ),
                },
                minLength: {
                  value: MIN_LENGTH,
                  message: (
                    <Error
                      message={`Must be at least ${MIN_LENGTH} characters`}
                    />
                  ),
                },
              })}
              className={`block w-full px-4 py-2 mt-1 transition duration-150 ease-in-out rounded-lg form-input ${
                errors[name]?.message ? 'border-red-300' : 'border-gray-300'
              }`}
            />
          )}
        </div>
      </label>
      {errors[name]?.message}
    </div>
  );
}

Input.propTypes = {
  errors: PropTypes.object,
  label: PropTypes.string.isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  register: PropTypes.func.isRequired,
  step: PropTypes.number,
  required: PropTypes.bool,
  type: PropTypes.string,
};

export { Input };
